class SoldOutTooltip {
  constructor() {
    this.init();
    this.setupMutationObserver();
  }

  setupMutationObserver() {
    // Create mutation observer to watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain our target elements
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (
              node.matches('.badge.badge--sold-out') || 
              node.querySelector('.badge.badge--sold-out')
            )) {
              console.log('Sold out badge updated, reinitializing tooltips');
              this.reinitialize();
            }
          });
        }
      });
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also listen for variant change events
    document.addEventListener('variant:change', () => {
      console.log('Variant changed, reinitializing sold out tooltips');
      this.reinitialize();
    });

    document.addEventListener('variant:changed', () => {
      console.log('Variant changed (alternate event), reinitializing sold out tooltips');
      this.reinitialize();
    });
  }

  reinitialize() {
    console.log('Reinitializing sold out tooltips...');
    // Remove existing tooltips
    document.querySelectorAll('.sold-out-tooltip-container').forEach(tooltip => {
      tooltip.remove();
    });
    // Add new tooltips after a short delay to ensure DOM is updated
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    // Find all sold out badge elements
    const soldOutElements = document.querySelectorAll('.badge.badge--sold-out');
    console.log('Found sold out elements:', soldOutElements.length);
    
    soldOutElements.forEach(element => {
      // Don't add tooltip if element already has one
      if (element.querySelector('.sold-out-tooltip-container')) {
        return;
      }

      // Create tooltip container
      const tooltipContainer = document.createElement('span');
      tooltipContainer.className = 'sold-out-tooltip-container';
      tooltipContainer.style.display = 'inline-block';
      tooltipContainer.style.marginLeft = '5px';
      tooltipContainer.style.position = 'relative';
      
      // Create tooltip icon
      const tooltipIcon = document.createElement('span');
      tooltipIcon.className = 'sold-out-tooltip-icon';
      tooltipIcon.innerHTML = 'info';
      tooltipIcon.style.display = 'inline-flex';
      tooltipIcon.style.alignItems = 'center';
      tooltipIcon.style.justifyContent = 'center';
      tooltipIcon.style.width = '65px';
      tooltipIcon.style.height = '22px';
      tooltipIcon.style.borderRadius = '50%';
      tooltipIcon.style.backgroundColor = '#DAF7A6';
      tooltipIcon.style.color = '#000000';
      tooltipIcon.style.fontSize = '16px';
      tooltipIcon.style.cursor = 'pointer';
      
      // Create tooltip content
      const tooltipContent = document.createElement('div');
      tooltipContent.className = 'sold-out-tooltip-content';
      tooltipContent.innerHTML = 'Kommer snart på lager igen';
      
      tooltipContent.style.position = 'absolute';
      tooltipContent.style.bottom = '100%';
      tooltipContent.style.left = '100%';
      tooltipContent.style.transform = 'translateX(-50%)';
      tooltipContent.style.padding = '4px 12px';
      tooltipContent.style.backgroundColor = '#DAF7A6';
      tooltipContent.style.color = '#333';
      tooltipContent.style.border = '1px solid #e0e0e0';
      tooltipContent.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      tooltipContent.style.borderRadius = '4px';
      tooltipContent.style.fontSize = '18px';
      tooltipContent.style.whiteSpace = 'wrap';
      tooltipContent.style.zIndex = '100';
      tooltipContent.style.display = 'none';
      tooltipContent.style.marginBottom = '8px';
      
      // Handle click events
      tooltipIcon.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent click from immediately triggering document click
        tooltipContent.style.display = tooltipContent.style.display === 'none' ? 'block' : 'none';
      });
      
      // Close tooltip when clicking anywhere else
      document.addEventListener('click', () => {
        tooltipContent.style.display = 'none';
      });
      
      // Assemble tooltip
      tooltipContainer.appendChild(tooltipIcon);
      tooltipContainer.appendChild(tooltipContent);
      
      // Add tooltip after badge text
      element.appendChild(tooltipContainer);
      console.log('Added tooltip for sold out badge');
    });
  }
}

// Initialize on page load
let soldOutTooltip;
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing sold out tooltip');
  soldOutTooltip = new SoldOutTooltip();
});

// Re-initialize on Shopify section updates
document.addEventListener('shopify:section:load', () => {
  console.log('Section loaded, reinitializing sold out tooltip');
  if (soldOutTooltip) {
    soldOutTooltip = new SoldOutTooltip();
  }
});
